import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { HeaderComponent } from './components/layouts/header/header.component';
import { AboutComponent } from './components/about/about.component';
import { SolutionsComponent } from './components/solutions/solutions.component';
import { ConsultingComponent } from './components/solutions/consulting/consulting.component';
import { ProductsComponent } from './components/solutions/products/products.component';
import { DcsAmlComponent } from './components/solutions/products/dcs-aml/dcs-aml.component';
import { MetricstreamComponent } from './components/solutions/products/metricstream/metricstream.component';
import { OutsourcingComponent } from './components/solutions/outsourcing/outsourcing.component';
import { PeopleComponent } from './components/people/people.component';
import { SpontaneousComponent } from './components/people/spontaneous/spontaneous.component';
import {EmploymentOpportunitiesComponent} from './components/people/employment-opportunities/employment-opportunities.component';
import { InsideComponent } from './components/inside/inside.component';
import { ContactsComponent } from './components/contacts/contacts.component';
import { LanguagePipe } from './pipes/language.pipe';
import { LanguageComponent } from './components/language/language.component';
import {AngularFontAwesomeModule} from 'angular-font-awesome';
import {CarouselModule} from 'ngx-owl-carousel-o';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SliderComponent} from './components/layouts/slider/slider.component';
import {FooterComponent} from './components/layouts/footer/footer.component';
import { HeaderInsideComponent } from './components/layouts/header-inside/header-inside.component';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { PostfilterPipe } from './pipes/postfilter.pipe';
import { PostsComponent } from './components/inside/posts/posts.component';
import { LoaderComponent } from './components/layouts/loader/loader.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    AboutComponent,
    SolutionsComponent,
    ConsultingComponent,
    ProductsComponent,
    DcsAmlComponent,
    MetricstreamComponent,
    OutsourcingComponent,
    PeopleComponent,
    SpontaneousComponent,
    EmploymentOpportunitiesComponent,
    InsideComponent,
    ContactsComponent,
    LanguagePipe,
    LanguageComponent,
    SliderComponent,
    FooterComponent,
    HeaderInsideComponent,
    PostfilterPipe,
    PostsComponent,
    LoaderComponent,
    PageNotFoundComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFontAwesomeModule,
    CarouselModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
